// var hash = require('hash.js')

class AuthManager {
  constructor (parseModel, router, store) {
    this.parseModel = parseModel
    this.router = router
    this.store = store
  }

  signIn () {
    return new Promise((resolve, reject) => {
      if (this.router.currentRoute.query.user && this.router.currentRoute.query.pass) {
        let user = this.router.currentRoute.query.user
        let password = this.router.currentRoute.query.pass
        this.parseModel.Parse.User.logIn(user, password)
        .then(user => {
          this.store.commit('saveUser', user)
          resolve(user)
        })
        .catch((error) => {
          console.log(`Login error for user ${this.router.currentRoute.query.deviceId}`, error)
          reject(error)
        })
      } else {
        reject(new Error('Login required.'))
      }
    })
  }

  signUp () {
    return new Promise((resolve, reject) => {
      var user = new this.parseModel.Parse.User()
      user.set('username', `Device_${this.router.currentRoute.query.deviceId}`)
      user.set('password', 'newPassword') // real password will be generated server side
      user.signUp(null).then(user => {
        this.store.commit('saveUser', user)
        resolve(user)
      }).catch(error => {
        reject(error)
      })
    })
  }

  /**
   * @param {*} required Auth required
   * @param {*} force force authentication without using current user
   */
  auth (force = false) {
    return new Promise(async (resolve, reject) => {
      var currentUser = this.parseModel.Parse.User.current()
      if (!force) {
        if (currentUser) {
          this.store.commit('saveUser', currentUser)
          return resolve(currentUser)
        }
      } else if (currentUser) {
        try {
          console.log("Logout");
          await this.parseModel.Parse.User.logOut()
        } catch(error) {
          console.error("Logout error", error);
        }
      }
      if ((force) || (!force && !this.parseModel.Parse.User.current())) {
        this.signIn().then(user => {
          resolve(user)
        }).catch(error => {
          reject(error)
        })
      }
    })
  }
}

export default {
  install: (Vue, options = {}) => {
    const name = options.name || 'authManager'

    var authManager = new AuthManager(Vue['vueParse'], options.router, options.store)

    Vue[name] = authManager
    Vue.prototype[`$${name}`] = authManager
  }
}



// WEBPACK FOOTER //
// ./src/tools/auth/authManager.js